import { render } from "./FireLicensing.vue?vue&type=template&id=38120eeb&scoped=true"
import script from "./FireLicensing.vue?vue&type=script&lang=js"
export * from "./FireLicensing.vue?vue&type=script&lang=js"

import "./FireLicensing.vue?vue&type=style&index=0&id=38120eeb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38120eeb"]])

export default __exports__